import { External } from '../external';

const BASE_URL = `https://${External.serviceApiDomain}/fulfillment`;

const FulfillmentService = {
  getProviderProducts: async (providerType, page, nextPageToken) => {
    const q = new URLSearchParams();
    q.append('page', page);
    if (nextPageToken) {
      q.append('nextPageToken', nextPageToken);
    }

    const url = `${BASE_URL}/products/${providerType}?${q.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Hash': External.WebPlatform.hash,
        'X-User-Hash': External.Website.hash
      }
    });
    return await response.json();
  }
};

export default FulfillmentService;
